var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardCardUpwardTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 15.1666C4.04659 15.1666 0.833252 11.9533 0.833252 7.99992C0.833252 4.04659 4.04659 0.833252 7.99992 0.833252C11.9533 0.833252 15.1666 4.04659 15.1666 7.99992C15.1666 11.9533 11.9533 15.1666 7.99992 15.1666ZM7.99992 1.83325C4.59992 1.83325 1.83325 4.59992 1.83325 7.99992C1.83325 11.3999 4.59992 14.1666 7.99992 14.1666C11.3999 14.1666 14.1666 11.3999 14.1666 7.99992C14.1666 4.59992 11.3999 1.83325 7.99992 1.83325Z",
    fill: "#12B76A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.8333C7.72667 10.8333 7.5 10.6066 7.5 10.3333V6.33325C7.5 6.05992 7.72667 5.83325 8 5.83325C8.27333 5.83325 8.5 6.05992 8.5 6.33325V10.3333C8.5 10.6066 8.27333 10.8333 8 10.8333Z",
    fill: "#12B76A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.16655C9.87338 8.16655 9.74671 8.11988 9.64671 8.01988L8.00004 6.37321L6.35338 8.01988C6.16004 8.21321 5.84004 8.21321 5.64671 8.01988C5.45338 7.82655 5.45338 7.50655 5.64671 7.31321L7.64671 5.31321C7.84004 5.11988 8.16004 5.11988 8.35338 5.31321L10.3534 7.31321C10.5467 7.50655 10.5467 7.82655 10.3534 8.01988C10.2534 8.11988 10.1267 8.16655 10 8.16655Z",
    fill: "#12B76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCardUpwardTickIcon);
export default __webpack_public_path__ + "static/media/dashboard-card-upward-tick-icon.79f0244b7bfbb4102909ce2f829c42ff.svg";
export { ForwardRef as ReactComponent };